import { classNames } from "@/react/helpers/twMergeWithCN";
import type { CardBrand } from "@/react/types/Paywalls/PaymentMethodTypes";
import { cardBrands } from "@/react/types/Paywalls/PaymentMethodTypes";
import type { IconProps } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";
import type { Variant, VariantProps } from "./types";

const iconTypeMap: Record<CardBrand, IconProps["type"]> = {
  amex: "paywalls-card-amex",
  diners: "paywalls-card-diners",
  discover: "paywalls-card-discover",
  jcb: "paywalls-card-jcb",
  mastercard: "paywalls-card-mastercard",
  unionpay: "paywalls-card-unionpay",
  visa: "paywalls-card-visa",
  generic: "paywalls-card-generic",
};
const variantPropsMap: Record<Variant, VariantProps> = {
  sm: {
    viewBox: "0 0 24 16",
    className: "!w-[24px] !h-[16px]",
  },
  md: {
    viewBox: "0 0 36 24",
    className: "!w-[36px] !h-[24px]",
  },
  lg: {
    viewBox: "0 0 54 36",
    className: "!w-[54px] !h-[36px]",
  },
  xl: {
    viewBox: "0 0 72 48",
    className: "!w-[72px] !h-[48px]",
  },
};

export interface CardBrandIconProps {
  cardBrand: CardBrand;
  className?: string;
  variant: Variant;
}
export const CardBrandIcon = ({
  cardBrand,
  variant,
  className,
}: CardBrandIconProps) => {
  const iconType = iconTypeMap[cardBrand];
  const { className: iconVariantClassName, ...iconVariantProps } =
    variantPropsMap[variant];
  const shouldUseStrokeCurrentColor = cardBrand === cardBrands.generic;
  return (
    <Icon
      {...iconVariantProps}
      className={classNames(className, iconVariantClassName)}
      useWithStrokeCurrentColor={shouldUseStrokeCurrentColor}
      type={iconType}
    />
  );
};
